import { Loader } from "~/components/Loader";

type Step = {
  title: string;
  description: string;
};

interface LoaderWithStepsProps {
  steps: Step[];
  currentStep: number;
}

export const LoaderWithSteps = ({
  steps,
  currentStep,
}: LoaderWithStepsProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] space-y-[32px]">
      <Loader size={64} className="h-[64px]" color="#2563EB" />
      <div>
        <h2 className="text-2xl font-semibold text-center">
          {steps[currentStep].title}
        </h2>
        <p className="text-[14px] text-[#71717A] mt-[16px] text-center">
          {steps[currentStep].description}
        </p>
      </div>
      <div className="flex items-center gap-[8px] ">
        {steps.map((_step, index) => (
          <div
            key={index}
            className={`w-[8px] h-[8px] rounded-full ${
              index === currentStep ? "bg-[#2563EB]" : "bg-[#F4F4F5]"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
};
